import HttpClient from "./httpClient";
import { ConfigurationSupportMessage, ConfigurationSupportSnapshot } from "../configurationSupport/types";

class ConfigurationSupportApi extends HttpClient {
  public ask = (payload: {
    snapshot: ConfigurationSupportSnapshot;
    question: string;
    history: ConfigurationSupportMessage[];
  }) =>
    this.post(
      "/api/configuration-support",
      { timeout: 90000 },
      {
        surface: payload.snapshot.surface,
        page_path: payload.snapshot.pagePath || "",
        configuration: payload.snapshot.configuration,
        question: payload.question,
        history: payload.history,
      }
    ) as Promise<{ answer: string }>;
}

export default ConfigurationSupportApi;
